import api from "../../index";

export const GetAllSourceApi = () => api.get('SalesDashboard/GetAll-Sales-Source');
export const AddSourceApi = (data, header) => api.post('SalesDashboard/Add-Update-Sales-Source', data, header);
export const DeleteSourceApi = (sourceId) => api.delete(`SalesDashboard/Delete-Sales-Source/${sourceId}`);